import latinize from 'latinize';

export const useToSlug = ({ withHash = false }: { withHash?: boolean } = {}) => {
    const hash = withHash ? '#' : '';
    return (name: string) => `${hash}${latinize(name).split(/\s+|-/).join('')}`;
};
